import React from "react";
import { TextInput, required } from 'react-admin';

import { GridForm, GridInput } from '../../../components/GridForm';
import { EmailInput, PhoneInput } from '../../../components/inputs';
import LanguageSelect from "components/inputs/LanguageSelect";
import { envSettings } from "core/EnvSettings";

const isServerDev = envSettings.REACT_APP_IS_SERVER_DEV;

export const DeveloperForm = ({ isCreate, ...props }) => (
	<GridForm {...props}>
		<GridInput sm={6} component={TextInput} source="first_name" autoFocus />
		<GridInput sm={6} component={TextInput} source="last_name" />
		<GridInput sm={6} component={PhoneInput} source="phone" />
		<GridInput sm={6} component={EmailInput} source="email" validate={[required()]}/>
		{isServerDev && isCreate ? 
			<GridInput sm={6} component={EmailInput} source="test_account_email" validate={[required()]} />
		: null}
		<GridInput sm={6} component={LanguageSelect} source="locale" defaultValue={isCreate ? "en" : undefined} /> 
	</GridForm>
);
